import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import themesConfig from 'app/fuse-configs/themesConfig'
import clsx from 'clsx'
import { ButtonWithLoading } from '../FormsyHelperComponent'

const useStyles = makeStyles(() => ({
  labelDelete: {
    backgroundColor: themesConfig.default.palette.button.delete.bg,
    color: themesConfig.default.palette.button.delete.text,
    '&.MuiButton-root:hover': {
      backgroundColor: themesConfig.default.palette.button.delete.onHover.bg,
    },
    '&.MuiButton-text.MuiButton-root:active': {
      backgroundColor: themesConfig.default.palette.button.delete.onPress.bg,
    },
  },
}))
const DeleteButton = ({ className, msgId, children, ...props }) => {
  const classes = useStyles()
  return (
    <ButtonWithLoading
      variant="text"
      className={clsx(classes.labelDelete, 'px-16', className)}
      CircularProp={{
        className: classes.loading,
      }}
      {...props}
    >
      <FormattedMessage id={msgId || 'action.delete'} />
    </ButtonWithLoading>
  )
}

export default DeleteButton
